// Création de l'objet à envoyer au back
const formaterFichierVersoLicenceSki = async (dataForm) => {
    return dataForm.versoLicenceSki ? dataForm.versoLicenceSki[0].getFileToSend() : null;
};

export default formaterFichierVersoLicenceSki;
